import { fetchWithAuth, getAuthHeader } from "./http.service";
const API_URL = (process.env.REACT_APP_API_URL || "") + "/api/admin/";

export interface Note {
  id: number;
  text: string;
  timestamp: string;
}

export interface OrderHistory {
  id: number;
  date: string;
  total: number;
  status: string;
  customerId: number;
}

export interface AppointmentHistory {
  id: number;
  date: string;
  service: string;
  status: string;
  customerId: number;
}

export interface Customer {
  id: number;
  username: string;
  email: string;
  role: string;
  notes: Note[];
  orders: OrderHistory[];
  appointments: AppointmentHistory[];
}

class CustomersService {
  getCustomers(): Promise<Customer[]> {
    return fetchWithAuth(API_URL + "customers", {
      method: "GET",
      headers: getAuthHeader(),
    }).then((response) => response.json());
  }
}

const customersService = new CustomersService();
export default customersService;
